var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('perspective-viewer',{ref:"pv",staticClass:"perspective-viewer-material-dark",attrs:{"columns":['Sales', 'Profit']}})}
var staticRenderFns = []

export { render, staticRenderFns }